var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('div',{staticClass:"view-container"},[_c('transition',{attrs:{"name":"slide","enter-active-class":"animated fadeIn fast"}},[_c('router-view')],1)],1),_c('div',{staticClass:"cover"}),_c('navbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }